import React, { createContext, useContext, useState } from "react";

const DataContext = createContext();

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
    // Products cache
    const [products, setProducts] = useState([]);
    const [productsFetched, setProductsFetched] = useState(false);
    const [productsLastDoc, setProductsLastDoc] = useState(null);
    const [productsHasMore, setProductsHasMore] = useState(true);

    // Blogs cache
    const [blogs, setBlogs] = useState([]);
    const [blogsFetched, setBlogsFetched] = useState(false);

    // Blog details cache (keyed by ID)
    const [blogDetails, setBlogDetails] = useState({});

    // Product details cache (keyed by ID)
    const [productDetails, setProductDetails] = useState({});

    const value = {
        // Products
        products,
        setProducts,
        productsFetched,
        setProductsFetched,
        productsLastDoc,
        setProductsLastDoc,
        productsHasMore,
        setProductsHasMore,

        // Blogs
        blogs,
        setBlogs,
        blogsFetched,
        setBlogsFetched,

        // Blog Details
        blogDetails,
        setBlogDetails,

        // Product Details
        productDetails,
        setProductDetails,
    };

    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export default DataContext;
